package org.vreo.devicehub.features.core.data.protocolBuffer.mappers

import androidx.compose.ui.geometry.Offset

import org.vreo.devicehub.features.core.domain.device.roi.Roi
import vreo.volt.protocol.RoiConfiguration
import vreo.volt.protocol.RoiList
import vreo.volt.protocol.RoiRegion

/**
 * Map list of ROI instances to list of ROI configuration protobuf messages
 *
 * @return list of ROI configuration protobuf messages
 */
fun List<Roi>.toRoiListProto(): RoiList {
    return RoiList(rois = this.map { it.toRoiConfiguration() })
}

/**
 * Map list of ROI configuration protobuf messages to list of ROI instances
 *
 * @return list of ROI instances
 */
fun RoiList.toRois(): List<Roi> {
    return this.rois.map { it.toRoi() }
}

/**
 * Map ROI instance to protobuf message
 *
 * @return ROI configuration protobuf message
 */
private fun Roi.toRoiConfiguration(): RoiConfiguration {
    val roiRegion = try {
        RoiRegion(
            x1 = (points[0].x * frameWidth).toInt(),
            y1 = (points[0].y * frameHeight).toInt(),
            x2 = (points[1].x * frameWidth).toInt(),
            y2 = (points[1].y * frameHeight).toInt(),
            x3 = (points[2].x * frameWidth).toInt(),
            y3 = (points[2].y * frameHeight).toInt(),
            x4 = (points[3].x * frameWidth).toInt(),
            y4 = (points[3].y * frameHeight).toInt()
        )
    } catch (e: Exception) {
        throw IllegalArgumentException("Failed to map ROI points to protobuf, error: ${e.message}")
    }

    return RoiConfiguration(
        bay_id = this.id,
        enable = true,
        frame_width = this.frameWidth,
        frame_height = this.frameHeight,
        coordinates = roiRegion
    )
}

/**
 * Map protobuf message to ROI instance
 *
 * @return ROI instance
 */
private fun RoiConfiguration.toRoi(): Roi {
    if (coordinates == null) {
        throw IllegalArgumentException("Specified coordinates is null")
    }

    val normalizedPoints = try {
        listOf(
            Offset(coordinates.x1.toFloat() / frame_width, coordinates.y1.toFloat() / frame_height),
            Offset(coordinates.x2.toFloat() / frame_width, coordinates.y2.toFloat() / frame_height),
            Offset(coordinates.x3.toFloat() / frame_width, coordinates.y3.toFloat() / frame_height),
            Offset(coordinates.x4.toFloat() / frame_width, coordinates.y4.toFloat() / frame_height)
        )
    } catch (e: Exception) {
        throw IllegalArgumentException("Failed to map protobuf points to ROI, error: ${e.message}")
    }

    return Roi(
        id = this.bay_id,
        label = "",
        frameHeight = this.frame_height,
        frameWidth = this.frame_width,
        points = normalizedPoints
    )
}



